









import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import CustomFieldService from '@/domain/custom-field/custom-field.service';
import CustomField from '@/domain/custom-field/custom-field.entity';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import SnackBarService from '@/shared/snackbar/snackbar.service';

@Component({ components: { ModalConfirm } })
export default class ProjectCustomFieldDeleteComponent extends Vue {
  @Prop() customFieldId!: string;

  dialogModal = false;

  @Watch('customFieldId')
  customFieldIdProjectId() {
    if (this.customFieldId) {
      this.openModalDeleteCustomField();
    }
  }

  openModalDeleteCustomField() {
    this.dialogModal = true;
  }

  cancelDeleteCustomField() {
    this.dialogModal = false;
    this.$emit('canceled');
  }

  deleteCustomField() {
    this.dialogModal = false;
    CustomFieldService
      .delete(this.customFieldId)
      .then(() => this.$emit('deleted'))
      .catch(err => SnackBarService.errorMessage(err.response.data.messages));
  }
}
